import { type AppliedCoupon } from '@hooks-api/types/dataModel/coupon'
import { type AppliedCouponCriterionsMap } from '../types'

/**
 * Parse appliedCoupons to AppliedCouponCriterionsMap
 */
export const parseAppliedCouponCriterionsMap = (appliedCoupons?: AppliedCoupon[]): AppliedCouponCriterionsMap | undefined => {
  return appliedCoupons?.flatMap(
    appliedCoupon => appliedCoupon.criterions,
  ).reduce<AppliedCouponCriterionsMap>((prev, curr) => ({
    ...prev,
    [curr.coupon_id]: {
      ...prev[curr.coupon_id],
      [curr.id]: curr,
    },
  }), {})
}
